import * as React from 'react';
import { useState } from 'react';

import { PlusBig } from '../../../icons';
import { EnhancedVirtualList } from '../../enhanced-virtual-list';
import { LinkComponent } from '../../index';
import { RoleData, UserData } from '../interfaces';
import { Styled } from '../styled';
import { UsersTabListItem } from './users-tab-list-item/users-tab-list-item';


interface Props {
  users: UserData[];
  userRoles: RoleData[];
  emptySeatsCount: number;
  maxUsersCount: number;
  disableEditUserList: string[];
  canInvite: boolean;
  resendInvitation?: (email: string) => void;
  addSeatsButtonClick?: () => void;
  changeUserRole?: (email: string, role: RoleData) => void;
  deleteUser?: (email: string) => void;
  addUserButtonClick?: () => void;
}

const UsersTabComponent: React.FC<Props> = ({
  users,
  changeUserRole,
  deleteUser,
  addUserButtonClick,
  userRoles,
  disableEditUserList,
  emptySeatsCount,
  canInvite,
  resendInvitation,
  addSeatsButtonClick,
}) => {
  const [userMenu, setUserMenu] = useState(null);
  const menuButtonClick = React.useCallback((target, email) => {
    const { left, top } = target.getBoundingClientRect();
    setUserMenu({ email, left, top });
  }, []);
  const closeMenu = React.useCallback(() => userMenu && setUserMenu(null), [!!userMenu]);
  const deleteUserHandler = React.useCallback((email) => {
    deleteUser(email);
    closeMenu();
  }, [deleteUser, closeMenu]);
  const changeUserRoleHandler = React.useCallback((email, role) => {
    changeUserRole(email, role);
    closeMenu();
  }, [closeMenu, changeUserRole]);

  const items = React.useMemo(() => users.concat(Array(emptySeatsCount).fill(null)), [emptySeatsCount, users]);

  const renderItem = React.useCallback((item: UserData | null) => {
    return (
      <UsersTabListItem
        resendInvitation={resendInvitation}
        menuButtonClick={menuButtonClick}
        userMenuInfo={userMenu}
        user={item}
        userRoles={userRoles}
        canInvite={canInvite}
        closeMenu={closeMenu}
        deleteUser={deleteUserHandler}
        changeUserRole={changeUserRoleHandler}
        disableEditUserList={disableEditUserList}
        addUserButtonClick={addUserButtonClick}
      />
    );
  }, [deleteUserHandler, changeUserRole, userRoles, userMenu, changeUserRoleHandler]);

  return (
    <Styled.UsersTab>
      <Styled.UsersContainer usersQuantity={users.length + emptySeatsCount}>
        <EnhancedVirtualList
          objects={items}
          itemHeight={Styled.USER_HEIGHT + 10}
          renderedItemsCount={5}
          renderItem={renderItem}
        />
      </Styled.UsersContainer>
      {addSeatsButtonClick &&
        <Styled.AddPeopleButton>
          <LinkComponent
            size='m'
            onClick={addSeatsButtonClick}
            Icon={PlusBig}
            text={'Buy more seats'}
          />
        </Styled.AddPeopleButton>
      }
    </Styled.UsersTab>
  );
};

export const UsersTab = React.memo(UsersTabComponent);

